import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ListenerRoom } from '@/components/ListenerRoom';
import { ArrowLeft } from 'lucide-react';

export function ListenerPage() {
  const { roomId } = useParams<{ roomId: string }>();
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate('/');
  };

  // Redirect to join page if no room ID
  if (!roomId) {
    navigate('/listener');
    return null;
  }

  return (
    <div className="container mx-auto py-4">
      <Button 
        variant="outline" 
        onClick={handleBackToHome}
        className="mb-4"
      >
        <ArrowLeft className="h-4 w-4 mr-2" />
        Back to Home
      </Button>
      <ListenerRoom roomId={roomId} />
    </div>
  );
}